import { twMerge } from 'tailwind-merge';

export const WidgetCard = ({ title, Icon, className, children }) => {
  return (
    <div
      className={twMerge(
        'w-full p-4 bg-brand-300/[0.08] rounded-xl truncate',
        className,
      )}
    >
      <div className="flex items-center gap-2 border-b border-b-brand-300/30 pb-4">
        <div className="w-7 h-7 rounded-lg flex items-center justify-center bg-purple-500 shrink-0">
          <Icon className="w-5 h-5 text-base-1000" />
        </div>
        <span className="text-base-1000 font-medium text-[14px]/[20px] truncate">
          {title}
        </span>
      </div>
      {children}
    </div>
  );
};
